import { createReducer, on } from '@ngrx/store';
import * as ShowActions from './show.actions';
import { Show } from './show.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ShowsState {
    shows: Show[];
    isLoading: boolean;
    error: string | null;
}

export interface ShowState {
    show: Show;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialShowsState: ShowsState = {
    shows: [],
    isLoading: false,
    error: null,
};

export const initialShowState: ShowState = {
    show: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Shows Reducer
export const showsReducer = createReducer(
    initialShowsState,

    // On Load Shows
    on(ShowActions.loadShows, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ShowActions.loadShowsSuccess, (state, { shows }) => ({
        ...state,
        isLoading: false,
        shows: shows,
    })),
    on(ShowActions.loadShowsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(ShowActions.createShow, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ShowActions.createShowSuccess, (state, { show }) => ({
        ...state,
        isLoading: false,
        shows: [...state.shows, show],
    })),
    on(ShowActions.createShowFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(ShowActions.updateShow, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ShowActions.updateShowSuccess, (state, { show }) => ({
        ...state,
        isLoading: false,
        shows: state.shows.map((s) => (s.id === show.id ? show : s)),
    })),
    on(ShowActions.updateShowFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(ShowActions.deleteShow, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ShowActions.deleteShowSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        shows: state.shows.filter((s) => s.id !== id),
    })),
    on(ShowActions.deleteShowFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);

// Single Show Reducer
export const showReducer = createReducer(
    initialShowState,

    // On Load Single Show
    on(ShowActions.loadShow, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ShowActions.loadShowSuccess, (state, { show }) => ({
        ...state,
        isLoading: false,
        show: show,
    })),
    on(ShowActions.loadShowFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
